import React, {useEffect, useState} from 'react';

import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

import {useUpdateMaxUsersLimit} from 'app/settings/api';
import {gt} from 'app/utils/i18n';

interface Props {
  accountId: number;
  currentLimit: number;
  show: boolean;
  onClose: () => void;
}

export function UpdateMaxUsersLimitModal({
  accountId,
  currentLimit,
  show,
  onClose,
}: Props) {
  const [limit, setLimit] = useState(currentLimit.toString());
  const [updateMaxUsersLimit, {isLoading, isSuccess}] =
    useUpdateMaxUsersLimit();

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const limitValue = parseInt(limit, 10);

    updateMaxUsersLimit({
      account_id: accountId,
      max_users_limit: limitValue,
    }).unwrap();
  }

  const limitNum = parseInt(limit, 10);
  const isValid = !isNaN(limitNum) && limitNum >= 20 && limitNum % 10 === 0;

  return (
    <Modal isOpen={show} toggle={onClose} backdrop="static">
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={onClose}>
          {gt('Update Max Members Limit')}
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="max-users-limit-input">
              {gt('Max members limit')}
            </label>
            <input
              type="number"
              id="max-users-limit-input"
              className="form-control"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
              min={20}
              step={10}
              required
            />
            <small className="form-text text-muted">
              {gt('Must be at least 20 and a multiple of 10')}
            </small>
            <small className="mt-2">
              <i>
                *
                {gt(
                  'This is the maximum number of members that can be added to your account. You can increase this limit if you want to allow adding more members'
                )}
              </i>
            </small>
            {!isValid && limit && (
              <div className="text-danger mt-1">
                {gt('Please enter a valid limit (minimum 20, multiple of 10)')}
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            {gt('Cancel')}
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!isValid || isLoading}
          >
            {isLoading ? gt('Updating...') : gt('Update')}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
